import React from 'react';
import { Link } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import { HoverLogo, HoverLogoWhite } from '../../../icons';

export interface LogoProps {
  isNavbarWhite: boolean;
  titleColor?: string;
}

const Logo = ({ titleColor, isNavbarWhite }: LogoProps) => {
  let logo;

  if (titleColor || isNavbarWhite) {
    logo = (
      <HoverLogo
        title="HOVER"
        alt="HOVER Logo"
        role="img"
        style={{ width: 147, height: 36 }}
      />
    );
  } else {
    logo = (
      <HoverLogoWhite
        title="HOVER"
        role="img"
        alt="HOVER Logo"
        style={{ width: 147, height: 36 }}
      />
    );
  }

  return (
    <Link as={GatsbyLink} to="/" aria-label="Hover homepage">
      {logo}
    </Link>
  );
};

export default Logo;
